import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  RSelect
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Table from "../../components/react-table/Table";
import { DELETE, GET } from "../../helper/api";
import { BILL_STATUS, BILL_TYPE } from "../../utils/Utils";


const BILL_STATUS_OPTIONS = Object.keys(BILL_STATUS).map((c) => ({
  label: BILL_STATUS[c],
  value: c,
}));

const MyBillForExternalPortFeeManager = () => {

  const history = useHistory();
  const clearPagi = useRef();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [view, setView] = useState({
    edit: false,
    add: false,
    isDelete: false,
  });
  const [loading, setLoading] = useState(false);

  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [updatedAt, setUpdatedAt] = useState();
  const [smOption, setSmOption] = useState(false);
  const [filter, setFilter] = useState({
    status: searchParams.get("status") || undefined,
  });

  const [rangeDate, setRangeDate] = useState({
    start: searchParams.get('start') ? moment(searchParams.get('start')).startOf('days').toDate() : moment().startOf("months").toDate(),
    end: searchParams.get('end') ? moment(searchParams.get('end')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({
      start: start ? moment(start)?.startOf("days").toDate() : start,
      end: end ? moment(end)?.endOf("days").toDate() : end,
    });
    if (start && end) {
      setUpdatedAt(moment().valueOf());
    }
  };

  const colTable = [
    {
      Header: "Mã",
      accessor: "id",
    },

    {
      Header: "Khách hàng",
      accessor: (item) => item?.customer?.name || "",
    },

    {
      Header: "Loại",
      accessor: (item) => BILL_TYPE[item.type],
    },
    {
      Header: "Nguyên liệu",
      accessor: (item) => item?.ingredient?.name || "",
    },
    {
      Header: "Biển số xe",
      accessor: (item) => item?.truckId || "",
    },
    {
      Header: "Chi phí(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.deliveryFeeByWeight || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Trạng thái",
      accessor: (item) => BILL_STATUS[item.status],
    },
    {
      Header: "Ngày tạo",
      accessor: (item) => moment(item.createdAt).format("DD/MM/YYYY HH:mm"),
    },
    {
      Header: "Ghi chú",
      accessor: (item) => item.note
    },
    {
      Header: "Hành động",
      accessor: (item) => (item?.status === 'INIT' ?
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        history.push(`/my-bill-for-external-port-fee-detail/${item.id}`);
                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Cập nhật</span>
                    </DropdownItem>
                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul> : <></>
      ),
    },
  ];

  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(filter.status ? { status: filter.status } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    setLoading(true);
    setData([]);
    clearTimeout(clearPagi.current);
    let params = {
      fromDate: moment(rangeDate.start).format('YYYY-MM-DD'),
      toDate: moment(rangeDate.end).format('YYYY-MM-DD'),
      ...(filter.status ? { status: filter.status } : {}),
    };

    GET(`/pn-bill-for-driver/list-for-external-port-fee`, params, true)
      .then(({ data: { rows, summary } }) => {
        setData([...rows]);
        setSummary(summary)
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow, updatedAt, filter]);


  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };


  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false });
  };

  const deleteOrder = (id) => {
    if (!id) {
      return;
    }

    DELETE(`/pn-bill-for-driver/delete-external-port-fee/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa danh mục thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  return (
    <React.Fragment>
      <Head title="Quản lý phí cảng bãi"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Quản lý phí cảng bãi</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div>
                        <DatePicker
                          selected={rangeDate.start}
                          startDate={rangeDate.start}
                          onChange={onRangeChange}
                          endDate={rangeDate.end}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div>
                        <RSelect
                          isClearable
                          classNamePrefix="form-control"
                          placeholder="Lọc theo trạng thái"
                          options={BILL_STATUS_OPTIONS}
                          value={BILL_STATUS_OPTIONS.find(
                            (c) => c.value === filter.status
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              status: val?.value || undefined
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div>
                        <Button color="primary" onClick={() => history.push('/my-bill-for-external-port-fee-detail/create')}>
                          <Icon name="plus"></Icon>
                          <span>Thêm phí cảng bãi</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                    headerRow={<tr className="font-weight-bold">
                      <td colSpan={5}>Tổng cộng tiền chi(đ):</td>
                      <td className="nk-tb-col text-right">
                        <NumericFormat
                          value={summary?.deliveryFeeByWeight}
                          displayType={"text"}
                          decimalScale={2}
                          thousandSeparator={","}
                          thousandsGroupStyle="thousand"
                        />
                      </td>
                      <td className="nk-tb-col text-right"></td>
                      <td className="nk-tb-col text-right"></td>
                      <td className="nk-tb-col text-right"></td>
                      <td className="nk-tb-col text-right"></td>
                    </tr>}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá phí cảng bãi này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteOrder(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default MyBillForExternalPortFeeManager;
